import { Theme, Tooltip, TooltipProps } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import styles from './ccf-tooltip.module.scss';
import { CSSProperties } from 'react';


export interface CcfTooltipProps extends TooltipProps{
  tooltipForRTL?:string;
  styles?: { ccfTooltipArrow: CSSProperties, ccfTooltip: CSSProperties }
  // interactive:boolean;
}
/**
 * Component to display tooltip 
 * @param param0 - CcfTooltipProps
 * @example <CcfTooltip />
 * @returns 
 */
export function CcfTooltip({children,tooltipForRTL, styles, ...other}: CcfTooltipProps) {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      ccfTooltipArrow: {
        color: '#333333',
        ...styles?.ccfTooltipArrow,
      },
      ccfTooltipRight0: {
        marginRight: '0px',
        backgroundColor: '#333333',
        font: `normal normal normal 10px/10px ${theme?.typography?.fontFamily}`,
        letterSpacing: '0px',
        color: theme?.palette?.background?.paper,
        opacity: '1',
        paddingTop: '12px',
        paddingBottom: '12px',
      },
      ccfTooltip: {
        backgroundColor: '#333333',
        font: `normal normal normal 10px/10px ${theme?.typography?.fontFamily}`,
        letterSpacing: '0px',
        color: theme?.palette?.background?.paper,
        opacity: '1',
        paddingTop: '12px',
        paddingBottom: '12px',
        ...styles?.ccfTooltip,
      },
    })
  );
  const classes = useStyles();
  return (
    <Tooltip {...other} classes={{arrow: classes.ccfTooltipArrow, tooltip: `${tooltipForRTL && !styles?.ccfTooltipArrow?classes.ccfTooltipRight0:classes.ccfTooltip}`}}>
      {children}
    </Tooltip>
  );
}

export default CcfTooltip;
